var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "단지안내",
            "tabActive": "단위세대 평면안내",
            "bg": "/images/sub/complex/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("단지안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last position-relative",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("단위세대 평면안내")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "link-3d"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--xxs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-pill",
    attrs: {
      "block": "",
      "color": "primary",
      "outlined": "",
      "href": "https://my.matterport.com/show/?m=CyoWyQmtW6W",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("25 TYPE 3D 모델링보기")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-pill",
    attrs: {
      "block": "",
      "color": "primary",
      "outlined": "",
      "href": "https://my.matterport.com/show/?m=bX9uPnLQD2X",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("52 TYPE 3D 모델링보기")])])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "page-section__content"
  }, [_c('div', {
    staticClass: "unit-tabs"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--density-compact",
    attrs: {
      "grow": "",
      "hide-slider": "",
      "centered": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('tab-quarternary', {
      key: index,
      staticClass: "text-uppercase"
    }, [_vm._v(" " + _vm._s(item.area) + " " + _vm._s(item.type) + " TYPE ")])];
  })], 2)], 1)]), _c('div', {
    staticClass: "page-section__content"
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-tab-item', {
      key: index,
      attrs: {
        "eager": ""
      }
    }, [_c('div', {
      staticClass: "page-section__content"
    }, [_c('div', {
      staticClass: "v-data-table v-data-table--border v-data-table--line v-data-table--density-comfortable"
    }, [_c('div', {
      staticClass: "v-data-table__wrapper"
    }, [_c('table', [_c('thead', [_c('tr', [_vm._l(_vm.thead, function (item, index) {
      return [_c('th-primary', {
        key: index
      }, [_vm._v(" " + _vm._s(item) + " ")])];
    })], 2)]), _c('tbody', [_c('tr', [_c('th-secondary', [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" TYPE ")]), _vm._l(item.areas, function (area, index) {
      return [_c('td-primary', {
        key: index
      }, [_vm._v(_vm._s(area) + "㎡")])];
    })], 2)])])])])]), _c('div', {
      staticClass: "page-section__content"
    }, [_c('sheet-secondary', {
      staticClass: "py-md-40px",
      attrs: {
        "align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": `/images/sub/complex/unit/${item.type}-type.jpg`,
        "alt": ""
      }
    })])], 1)])];
  })], 2)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }